'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Paper = require('material-ui/Paper');

var _Paper2 = _interopRequireDefault(_Paper);

var _WMThemeProvider = require('../common/WMThemeProvider');

var _WMThemeProvider2 = _interopRequireDefault(_WMThemeProvider);

var _PropertyHelper = require('../common/PropertyHelper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
	children: _propTypes2.default.node.isRequired,
	circle: _propTypes2.default.bool,
	rounded: _propTypes2.default.bool,
	transitionEnabled: _propTypes2.default.bool,
	style: _propTypes2.default.object,
	zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
};

var allowedProperties = Object.keys(propTypes);

var WMPaper = function WMPaper(props) {
	return _react2.default.createElement(
		_WMThemeProvider2.default,
		null,
		_react2.default.createElement(_Paper2.default, (0, _PropertyHelper.filter)(props, allowedProperties))
	);
};

exports.default = WMPaper;


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMPaper/index.js